import BillingPriceMetadata from '@/datatypes/billing/price-metadata';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class SubscriptionAssignRequest {
  public enterpriseId: string;
  public externalBillingPriceId: string;
  public externalSubscriptionId: string;
  public metadata: BillingPriceMetadata = new BillingPriceMetadata({});

  constructor(options) {
    this.enterpriseId = options.enterpriseId;
    this.externalBillingPriceId = options.externalBillingPriceId;
    this.externalSubscriptionId = options.externalSubscriptionId;
    if (options.metadata) {
      this.metadata = new BillingPriceMetadata(camelcaseKeysDeep(options.metadata));
    }
  }

  complete(billingPrice) {
    if (billingPrice.payg()) {
      return (
        this.enterpriseId
        && this.externalBillingPriceId
        && this.externalSubscriptionId
        && this.metadata.completePayg()
      );
    }

    return (
      this.enterpriseId
      && this.externalBillingPriceId
      && this.externalSubscriptionId
      && this.metadata.completeLicensed()
    );
  }
}
